import { createContext } from 'react'
import { ComputedTeaserFlex } from '@widgets/Teaser/types'

export interface SportsHeaderContextType {
  teaserFlex: ComputedTeaserFlex
  teaserType: 'toi' | 'standard' | 'listitem'
  isInMegaModule: boolean
}

const SportsHeaderContext = createContext<SportsHeaderContextType>({
  teaserFlex: {
    desktop: '6',
    tablet: '6',
    mobile: '6',
  },
  teaserType: 'toi',
  isInMegaModule: false,
})

const exports = { SportsHeaderContext }

export default exports
